__turbopack_context__.v({
  "checked": "Checkbox-module-scss-module__zeniiW__checked",
  "icon": "Checkbox-module-scss-module__zeniiW__icon",
  "indeterminate": "Checkbox-module-scss-module__zeniiW__indeterminate",
  "indicator": "Checkbox-module-scss-module__zeniiW__indicator",
  "root": "Checkbox-module-scss-module__zeniiW__root",
});
